module.exports = __webpack_public_path__ + "img/image25.7c86a733.webp";